import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  /**
   *
   */
  constructor(private authService: AuthService, private router: Router) { }

  /**
   * 
   * @param next 
   * @param state 
   * @returns 
   */
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.currentState().isLoggedIn)
      return this.authService.canAccessRoute(next.url) ? true : this.router.parseUrl('/');
    else
      this.router.navigate(['/'], {
        queryParams: {
          return: state.url
        }
      });
    //return this.authService.canAccessRoute(next.url) ? true : this.router.parseUrl('/');
  }

}
